import React from 'react'
import './special.css'

export default function special() {
  return (
    <div className='special'>
      <div className='special-top'>
        <h3 className='special-text'>This week Specials!</h3>
        <div className='special-btn'>Online Menu</div>
      </div>
      
    </div>
  )
}
